export default "__VITE_ASSET__GPQoq5f7__"